export default {
  // Europe
  EU: 'EU',
  // North America
  NA: 'NA',
}
